<template>
  <el-popover placement="bottom" trigger="click">
    <el-row
      class="row padding-left-10 padding-right-10"
      type="flex"
      align="middle"
      v-for="([label, value], index) in Object.entries(columns)"
      :key="index"
    >
      <el-switch
        :value="value"
        @input="eventValue => change(eventValue, { label, value }, index)"
      ></el-switch>
      <span style="padding-left: 10px">{{ label }}</span>
    </el-row>
    <slot v-if="$slots.default" slot="reference"></slot>
    <el-button
      v-else
      :size="size"
      slot="reference"
      style="margin-left: 10px"
    >列设置</el-button>
  </el-popover>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
    },
    cache: {
      type: [String, Boolean],
      default: 'TABLE_COLUMN_SWITCH',
    },
    name: {
      type: String,
      required: true,
    },
    columns: {
      type: Object,
      required: true,
    },
    onChange: {
      type: Function,
    },
  },
  created() {
    this.mergeCache();
  },
  methods: {
    mergeCache() {
      if (!this.cache) return;

      const cache = window.localStorage.getItem(this.cache);
      const columnsCache = (cache ? JSON.parse(cache) : {})[this.name];
      const columns = JSON.parse(JSON.stringify(this.columns));
      if (columnsCache) {
        Object.keys(columnsCache).forEach(
          (key) => typeof columns[key] === 'undefined' && delete columnsCache[key],
        );
      }

      Object.assign(columns, columnsCache ?? {});
      window.localStorage.setItem(
        this.cache,
        JSON.stringify(Object.assign(cache ? JSON.parse(cache) : {}, { [this.name]: columns })),
      );
      this.$emit('update:columns', columns);
    },
    change(value, column, index) {
      const cache = window.localStorage.getItem(this.cache);
      const columns = JSON.parse(JSON.stringify(this.columns));
      columns[column.label] = value;

      if (this.cache) {
        window.localStorage.setItem(
          this.cache,
          JSON.stringify(Object.assign(cache ? JSON.parse(cache) : {}, { [this.name]: columns })),
        );
      }

      this.$emit('update:columns', columns);
      if (this.onChange) this.onChange(value, column, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.row + .row {
  margin-top: 10px;
}
</style>
